import { GenericBaryFormGroup, IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { IFormBuilder } from '../IFormBuilder';
import { FormControl, ValidatorFn } from '@angular/forms';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';
import { CarouselItem } from '../../carousel-item.model';

interface ICarouselItemFormBuilder extends IFormBuilder<CarouselItemControls> {
  init(): ICarouselItemFormBuilder;

  build(): IGenericBaryFormGroup<CarouselItemControls>;
}

export type CarouselItemControls = {
  image: FormControl;
  title: FormControl;
  description: FormControl;
};

export class CarouselItemFormBuilder implements ICarouselItemFormBuilder {
  private formName = 'carouselItemForm';
  private controls?: CarouselItemControls;
  private validators?: ValidatorFn[];

  constructor(private bcf: BaryFormFactoryService) {}

  init(carouselItem?: CarouselItem): CarouselItemFormBuilder {
    this.controls = this.bcf.makeCarouselItemControls(carouselItem);
    this.applyTransporterConfiguration();
    return this;
  }

  private applyTransporterConfiguration(): void {
    this.validators = [];
  }

  build(): IGenericBaryFormGroup<CarouselItemControls> {
    return new GenericBaryFormGroup<CarouselItemControls>(this.formName, this.controls!, this.validators);
  }
}
